export const AppConfig = {
  passwordPattern:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*/\-\+])(?=.{8,})/,
  emailPattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  phonePattern: /^[0-9]{2,4}[-.\s]?[0-9]{2,4}[-.\s]?[0-9]{4,6}$/,
};
